<app-general-errors [errors]="errorsArr"></app-general-errors>

<div id="complaintEdit" class="complaint-edit">
  <mat-stepper linear="" #stepper [orientation]="(stepperOrientation | async)!" class="complaint-edit__stepper"
               [class.header-hidden]="!showStepper()">
    <mat-step [stepControl]="complaintForm" editable class="complaint-edit__step complaint-edit__step--form">
      @if (messagesPresent) {
      <app-general-warning [warnings]="[{infoText: message}]"></app-general-warning>
      }
      <form [formGroup]="complaintForm" class="mt-3 complaint-edit__form">
        @if (!isMobile) {
          <ng-template matStepLabel>
            <div class="complaint-edit__step-label"
                 [innerHTML]="translationService.getTranslation('step_complaint')"></div>
          </ng-template>
        }
        @if (isMobile) {
          <div class="mx-1 complaint-edit__step-label--mobile">
            <h2 *appApplyIfNotEmpty="translationService.getTranslation('step_complaint')"
                [innerHTML]="translationService.getTranslation('step_complaint')"></h2>
          </div>
        }
        <mat-form-field class="complaint-edit__form-field">
          <mat-label class="complaint-edit__form-label"
                     [innerHTML]="translationService.getTranslation('complaint_reason')"></mat-label>
          <mat-select formControlName="reason" required aria-required="true" [value]="complaintForm.get('reason').value"
                      [compareWith]="compareBaseData" class="complaint-edit__select"
                      (selectionChange)="onReasonSelected()">
            @for (reason of reasons; track reason) {
              <mat-option class="complaint-edit__option" [value]="reason">{{ reason.description }}</mat-option>
            }
          </mat-select>
          @if (complaintForm.get('reason').hasError('message')) {
            <mat-error class="complaint-edit__error"
            >{{ complaintForm.get('reason').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
        <div class="mt-5 complaint-edit__form-actions">
          <button mat-raised-button color="primary" matStepperNext
                  [disabled]="complaintForm.invalid"
                  [innerHTML]="translationService.getTranslation('button_next')" class="complaint-edit__button">
          </button>
        </div>
      </form>
    </mat-step>
    @if (complaintDays?.complaintDaysArray?.length > 1) {
      <mat-step [stepControl]="complaintDueDatesForm" editable
                class="complaint-edit__step complaint-edit__step--duedates">
        <form [formGroup]="complaintDueDatesForm" class="mt-3 complaint-edit__form">
          @if (!isMobile && !isShowEditionInsteadOfDate) {
            <ng-template matStepLabel>
              <div class="complaint-edit__step-label"
                   [innerHTML]="translationService.getTranslation('step_complaintVariantDate')"></div>
            </ng-template>
          }
          @if (isShowEditionInsteadOfDate) {
            <ng-template matStepLabel>
              <div class="complaint-edit__step-label"
                   [innerHTML]="translationService.getTranslation('step_complaintBookNumber')"></div>
            </ng-template>
          }
          @if (isMobile) {
            <div class="mx-1 complaint-edit__step-label--mobile">
              <h2 *appApplyIfNotEmpty="translationService.getTranslation('step_complaintVariantDate')"
                  [innerHTML]="translationService.getTranslation('step_complaintVariantDate')"></h2>
            </div>
          }
          @if (complaintDays?.complaintDaysArray?.length > 0) {
            <div class="complaint-edit__days">
              @if (complaintDays?.complaintDaysArray?.length > 1 && !isSingleDateSelection) {
                <mat-checkbox
                  class="example-margin complaint-edit__checkbox-all"
                  [checked]="allComplete"
                  [indeterminate]="someComplete()"
                  (change)="setAll($event.checked)">
                  {{ complaintDays.name }}
                </mat-checkbox>
              }
              @if (isSingleDateSelection) {
                <mat-radio-group class="row complaint-edit__days-list complaintDays"
                                 [value]="selectedComplaintDayIndex"
                                 (change)="selectSingleComplaintDay($event.value)"
                                 [attr.aria-label]="translationService.getTranslation(isShowEditionInsteadOfDate ? 'step_complaintBookNumber' : 'step_complaintVariantDate')">
                  @for (complaintDay of complaintDueDatesFormDateArray.controls; track complaintDay; let i = $index) {
                    <div class="col-6 col-md-4 col-lg-3 col-xl-2 complaint-edit__days-item">
                      <mat-radio-button [value]="i" class="complaint-edit__radio">
                        {{ getComplaintDayLabel(i) }}
                      </mat-radio-button>
                    </div>
                  }
                </mat-radio-group>
              } @else {
                <div class="row complaint-edit__days-list complaintDays">
                  @for (complaintDay of complaintDueDatesFormDateArray.controls; track complaintDay; let i = $index) {
                    <div formArrayName="dates" class="col-6 col-md-4 col-lg-3 col-xl-2 complaint-edit__days-item">
                      <mat-checkbox [formControlName]="i" (change)="changeComplaintDay(i)"
                                    class="complaint-edit__checkbox">
                        {{ getComplaintDayLabel(i) }}
                      </mat-checkbox>
                    </div>
                  }
                </div>
              }
              <div class="mt-5 complaint-edit__form-actions">
                <button class="me-3 complaint-edit__button" mat-raised-button
                        matStepperPrevious [innerHTML]="translationService.getTranslation('button_back')">
                </button>
                <button mat-raised-button color="primary" matStepperNext
                        (click)="loadComplaintActionsByCodeAndDate(complaintForm.get('reason')?.value?.key)"
                        [innerHTML]="translationService.getTranslation('button_next')" class="complaint-edit__button">
                </button>
              </div>
            </div>
          } @else {
            <div class="complaint-edit__no-days"
                 [innerHTML]="translationService.getTranslation('complaint_no_deliverydays_found')"></div>
          }
        </form>
      </mat-step>
    }

    <!-- Bilder hochladen -->
    @if (imageUpload) {
      <mat-step [stepControl]="complaintImagesForm" editable class="complaint-edit__step complaint-edit__step--images">
        <ng-template matStepLabel>{{ translationService.getTranslation('stepper_step_upload') }}</ng-template>
        <app-image-uploader #uploader (imagesUploaded)="onImageSelected($event)"
                            class="complaint-edit__image-uploader"></app-image-uploader>
        <div class="mt-5 complaint-edit__form-actions">
          <button class="me-3 complaint-edit__button" mat-raised-button
                  matStepperPrevious [innerHTML]="translationService.getTranslation('button_back')">
          </button>
          <button mat-raised-button color="primary" matStepperNext
                  [innerHTML]="imageComponent?.files?.length === 0 ? translationService.getTranslation('button_step_over') : translationService.getTranslation('button_next')"
                  class="complaint-edit__button">
          </button>
        </div>
      </mat-step>
    }
    <!-- Kompensation (opt.) -->
    @if (compensationStep) {
      <mat-step [stepControl]="complaintCompensationForm" editable
                class="complaint-edit__step complaint-edit__step--compensation">
        <form [formGroup]="complaintCompensationForm" class="mt-3 complaint-edit__form">
          @if (!isMobile) {
            <ng-template matStepLabel>
              <div class="complaint-edit__step-label"
                   [innerHTML]="translationService.getTranslation('step_complaintCompensation')"></div>
            </ng-template>
          }
          @if (isMobile) {
            <div class="mx-1 complaint-edit__step-label--mobile">
              <h2 *appApplyIfNotEmpty="translationService.getTranslation('step_complaint_compensation')"
                  [innerHTML]="translationService.getTranslation('step_complaint_compensation')"></h2>
            </div>
          }
          <mat-form-field class="complaint-edit__form-field">
            <mat-label class="complaint-edit__form-label"
                       [innerHTML]="translationService.getTranslation('complaint_compensation')"></mat-label>
            <mat-select formControlName="compensation" required aria-required="true"
                        [value]="complaintCompensationForm.get('compensation')" class="complaint-edit__select">
              @for (reason of complaintActions; track reason) {
                <mat-option class="complaint-edit__option" [value]="reason">{{ reason.description }}</mat-option>
              }
            </mat-select>
            @if (complaintCompensationForm.get('compensation').hasError('message')) {
              <mat-error class="complaint-edit__error"
              >
                {{ complaintCompensationForm.get('compensation').getError('message') }}
              </mat-error>
            }
          </mat-form-field>
          <div class="mt-5 complaint-edit__form-actions">
            <button class="me-3 complaint-edit__button" mat-raised-button
                    matStepperPrevious [innerHTML]="translationService.getTranslation('button_back')"></button>
            <button mat-raised-button color="primary" matStepperNext
                    (click)="getPriceForComplaint()" [innerHTML]="translationService.getTranslation('button_next')"
                    class="complaint-edit__button"></button>
          </div>
        </form>
      </mat-step>
    }

    @if (getComplaintCode().withMemoFlag) {
      <mat-step [stepControl]="complaintMemoForm" editable class="complaint-edit__step complaint-edit__step--memo">
        <form [formGroup]="complaintMemoForm" class="mt-3 complaint-edit__form">
          @if (!isMobile) {
            <ng-template matStepLabel>
              <div class="complaint-edit__step-label"
                   [innerHTML]="translationService.getTranslation('step_complaint_memo')"></div>
            </ng-template>
          }
          @if (isMobile) {
            <div class="mx-1 complaint-edit__step-label--mobile">
              <h2 *appApplyIfNotEmpty="translationService.getTranslation('step_complaint_memo')"
                  [innerHTML]="translationService.getTranslation('step_complaint_memo')"></h2>
            </div>
          }
          <mat-form-field class="complaint-edit__form-field">
            <mat-label class="complaint-edit__form-label"
                       [innerHTML]="translationService.getTranslation('complaint_reasonMemo')"></mat-label>
            <textarea maxlength="1000" matInput cdkAutosizeMinRows="3" cdkTextareaAutosize formControlName="memo"
                      [value]="complaintMemoForm.get('memo').value" #reasonMemo
                      class="complaint-edit__textarea"></textarea>
            @if (document != null && reasonMemo === document?.activeElement && reasonMemo.value.length >= 1) {
              <mat-hint align="end" class="complaint-edit__hint">{{ reasonMemo.value.length }}
                / {{ reasonMemo.maxLength }}
              </mat-hint>
            }
            @if (complaintMemoForm.get('memo').hasError('message')) {
              <mat-error class="complaint-edit__error"
              >{{ complaintMemoForm.get('memo').getError('message') }}
              </mat-error>
            }
          </mat-form-field>
          <div class="mt-5 complaint-edit__form-actions">
            <button class="me-3 complaint-edit__button"
                    mat-raised-button
                    matStepperPrevious [innerHTML]="translationService.getTranslation('button_back')">
            </button>
            <button mat-raised-button color="primary" matStepperNext
                    (click)="getPriceForComplaint()" [innerHTML]="translationService.getTranslation('button_next')"
                    class="complaint-edit__button">
            </button>
          </div>
        </form>
      </mat-step>
    }

    <mat-step class="complaint-edit__step complaint-edit__step--summary">
      @if (!isMobile) {
        <ng-template matStepLabel>
          <div class="complaint-edit__step-label" [innerHTML]="translationService.getTranslation('step_summary')"></div>
        </ng-template>
      }
      @if (isMobile) {
        <div class="mx-1 complaint-edit__step-label--mobile">
          <h2 *appApplyIfNotEmpty="translationService.getTranslation('step_summary')"
              [innerHTML]="translationService.getTranslation('step_summary')"></h2>
        </div>
      }
      <div class="mt-3 complaint-edit__summary">
        <h5 *appApplyIfNotEmpty="translationService.getTranslation('step_complaint')"
            [innerHTML]="translationService.getTranslation('step_complaint')"
            class="complaint-edit__summary-title"></h5>
        <div class="container-fluid p-0 complaint-edit__summary-container">
          <div class="row m-0 complaint-edit__summary-row">
            @if (!isShowEditionInsteadOfDate) {
              <div class="col-6 complaint-edit__summary-label"
                   [innerHTML]="translationService.getTranslation('date')"></div>
            }
            @if (isShowEditionInsteadOfDate) {
              <div class="col-6 complaint-edit__summary-label"
                   [innerHTML]="translationService.getTranslation('step_complaintBookNumber')"></div>
            }
            <div class="col-6 complaint-edit__summary-value">
              @if (isShowEditionInsteadOfDate) {
                <ul class="ps-0 complaint-edit__summary-list">
                  @for (booknumber of getSelectedDates(); track booknumber) {
                    <li class="complaint-edit__summary-list-item"> {{ booknumber }}</li>
                  }
                </ul>
              }
              @if (!isShowEditionInsteadOfDate) {
                <ul class="ps-0 complaint-edit__summary-list">
                  @for (day of getSelectedDates(); track day) {
                    <li
                      class="complaint-edit__summary-list-item"> {{ day | date: translationService.getTranslation('dateFormat') }}
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
          <div class="row m-0 complaint-edit__summary-row">
            <div class="col-6 complaint-edit__summary-label"
                 [innerHTML]="translationService.getTranslation('complaint_reason')"></div>
            <div class="col-6 complaint-edit__summary-value">{{ complaintForm.get('reason')?.value?.description }}</div>
          </div>
          @if (complaintMemoForm.get('memo').value !== '') {
            <div class="row m-0 complaint-edit__summary-row">
              <div class="col-6 complaint-edit__summary-label"
                   [innerHTML]="translationService.getTranslation('complaint_reasonMemo')"></div>
              <div class="col-6 complaint-edit__summary-value">{{ complaintMemoForm.get('memo').value }}</div>
            </div>
          }
          @if (imageUpload) {
            <div>
              @if (imageComponent?.files?.length > 0) {
                <div class="row m-0 complaint-edit__summary-row">
                  <div
                    class="col-6 complaint-edit__summary-label">{{ translationService.getTranslation('complaint.attachments') }}
                  </div>
                  <div
                    class="col-6 complaint-edit__summary-value">{{ imageComponent?.files?.length }} {{ translationService.getTranslation('file_or_files') }}
                  </div>
                </div>
              }
            </div>
          }
        </div>
        <mat-divider class="mb-1 mt-3 complaint-edit__divider"></mat-divider>

        @if (compensationStep || complaintCompensationForm.get('compensation').value?.code) {
          <h5 *appApplyIfNotEmpty="translationService.getTranslation('step_complaintCompensation')"
              [innerHTML]="translationService.getTranslation('step_complaintCompensation')"
              class="complaint-edit__summary-title"></h5>
          <div class="container-fluid p-0 complaint-edit__summary-container">
            <div class="row m-0 complaint-edit__summary-row">
              <div class="col-6 complaint-edit__summary-label"
                   [innerHTML]="translationService.getTranslation('complaint_compensation')"></div>
              <div
                class="col-6 complaint-edit__summary-value">{{ complaintCompensationForm.get('compensation').value.description }}
              </div>
            </div>
          </div>
        }

        @if (isSaving) {
          <div style="text-align: center;" class="complaint-edit__loading">
            <app-loading-spinner/>
          </div>
        }

        <br/>
        <div class="mt-5 complaint-edit__form-actions">
          <button class="me-3 complaint-edit__button"
                  mat-raised-button
                  matStepperPrevious [innerHTML]="translationService.getTranslation('button_back')">
          </button>
          <button mat-raised-button color="primary" [hidden]="isSaving" (click)="onSend()"
                  [innerHTML]="translationService.getTranslation('button_send')" class="complaint-edit__button">
          </button>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
</div>
<div class="mt-3 float-end complaint-edit__back">
  @if (showBackToOverviewButton) {
    <button
      mat-raised-button (click)="backToOverview()"
      [innerHTML]="translationService.getTranslation('button_back_to_overview')" class="complaint-edit__button">
    </button>
  }
</div>
